import { FunctionComponent } from "react";
import { FormattedMessage } from "react-intl";

interface FooterCategoryNameProps {
  id: string;
  defaultMessage: string;
}

const FooterCategoryName: FunctionComponent<FooterCategoryNameProps> = ({
  id,
  defaultMessage,
}) => {
  return (
    <h3 className="text-sm leading-5 font-semibold tracking-wider text-gray-400 uppercase">
      <FormattedMessage id={id} defaultMessage={defaultMessage} />
    </h3>
  );
};

export default FooterCategoryName;
